import type { SpreadsheetCellCoordinate } from './spreadsheetTypes'

export const SPREADSHEET_ROOT_ATTRIBUTE = 'data-spreadsheet-root'
export const SPREADSHEET_ROOT_SELECTOR = `[${SPREADSHEET_ROOT_ATTRIBUTE}="true"]`

export function isTargetInsideSpreadsheetRoot(
  target: EventTarget | null
): boolean {
  return (
    target instanceof Element &&
    Boolean(target.closest(SPREADSHEET_ROOT_SELECTOR))
  )
}

export function focusSpreadsheetCell(cell: SpreadsheetCellCoordinate | null) {
  if (!cell || typeof document === 'undefined') return

  window.requestAnimationFrame(() => {
    const matchingCell = document.querySelector<HTMLElement>(
      `${SPREADSHEET_ROOT_SELECTOR} [data-spreadsheet-cell="true"]` +
        `[data-spreadsheet-row-id="${CSS.escape(cell.rowId)}"]` +
        `[data-spreadsheet-column-id="${CSS.escape(cell.columnId)}"]`
    )
    matchingCell?.focus()
  })
}
